<template>
	<ul class="c-accordion" :aria-label="ariaLabel">
		<li
			class="c-accordion__fold"
			v-for="(item, index) in items"
			:key="index"
		>
			<button
				:id="item.id"
				:aria-expanded="isExpanded(index) ? 'true' : 'false'"
				:aria-controls="isExpanded(index) ? 'content' + index : null"
				class="c-accordion__label"
				type="button"
				@click="toggleExpand(index, item.kundoId, item.title)"
			>
				<span
					class="c-expand__icon"
					:class="{ 'c-expand__rotate': isExpanded(index) }"
				>
					<v-icon
						v-if="isExpanded(index)"
						name="icon-open-circle"
					></v-icon>
					<v-icon v-else name="icon-open-circle"></v-icon>
					<span class="t-visually-hidden">{{
						isExpanded(index) ? "Stäng" : "Öppna"
					}}</span>
				</span>
				<span
					class="c-accordion__title"
					v-html="decodeURIComponent(item.title)"
				></span>
			</button>
			<div
				:id="'content' + index"
				class="c-accordion__content"
				v-if="isExpanded(index)"
				:aria-hidden="!isExpanded(index) ? true : false"
				:aria-labelledby="item.id"
			>
				<div class="c-accordion__content-inner">
					<div v-html="decodeURIComponent(item.content)"></div>
					<div class="c-accordion__button" v-if="item.buttonUrl" tabindex="0">
						<a
							:href="item.buttonUrl"
							class="c-button c-button--primary"
						>
							<span class="c-button--right">{{
								item.buttonText
							}}</span>
							<v-icon name="icon-arrow" size="xxs"></v-icon>
						</a>
					</div>
				</div>
			</div>
		</li>
	</ul>
</template>

<script>
import VIcon from "../../components/icon/VIcon.vue";

export default {
	name: "VAccordion",
	components: {
		VIcon
	},
	props: {
		ariaLabel: {
			type: String,
			default: ""
		},
		items: {
			type: Array,
			default: () => []
		},
		openItems: {
			type: Array,
			default: () => []
		},
		kundoInstance: {
			type: String,
			default: ""
		},
		googleAnalyticsTrackingForQuestionsAndAnswers: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			indices: null
		};
	},
	computed: {
		expandedItemIndices() {
			if (!this.items) {
				return [];
			}
			var selectedItems = this.items
				.map((item, index) => ({ isOpen: item.isSelected, idx: index }))
				.filter(item => item.isOpen)
				.map(item => item.idx);
			var selectedItemsCombination = !selectedItems ? [] : selectedItems;
			if (this.openItems) {
				selectedItemsCombination = selectedItemsCombination.concat(
					this.openItems.filter(function(item) {
						return selectedItemsCombination.indexOf(item) < 0;
					})
				);
			}
			return selectedItemsCombination;
		}
	},
	methods: {
		toggleExpand(index, kundoId, title) {
			if (!this.indices) {
				if (!this.expandedItemIndices) {
					return;
				}
				this.indices = this.expandedItemIndices;
			}
			const currentPos = this.indices.indexOf(index);
			if (currentPos > -1) {
				// close item
				this.indices.splice(currentPos, 1);
			} else {
				if (this.kundoInstance) {
					this.async_load(this.kundoInstance, kundoId);
					if (window.attachEvent) {
						window.attachEvent(
							"onload",
							this.async_load(this.kundoInstance, kundoId)
						);
					} else {
						window.addEventListener(
							"load",
							this.async_load(this.kundoInstance, kundoId),
							false
						);
					}
				}

				// Google Analytics
				if (this.googleAnalyticsTrackingForQuestionsAndAnswers) {
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						event: "kundtjanstEvent",
						eventCategory: "Kundtjänst",
						eventAction: "Vanliga frågor",
						eventLabel: decodeURIComponent(title)
					});
				}
				// open item
				this.indices.push(index);
			}
		},
		async_load(instance, id) {
			var s = document.createElement("script");
			s.type = "text/javascript";
			s.async = true;
			s.src = `https://kundo.se/api/analytics/tracker/${instance}/${id}.js`;
			var x = document.getElementsByTagName("script")[0];
			x.parentNode.insertBefore(s, x);
		},
		isExpanded(index) {
			if (!this.indices) {
				this.indices = this.expandedItemIndices;
			}
			return this.indices && this.indices.indexOf(index) > -1;
		}
	}
};
</script>
